import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgxsModule } from "@ngxs/store";
import { TransportState } from "./transport.state";

 @NgModule({
  imports: [CommonModule, NgxsModule.forFeature([TransportState])],
  declarations: []
})
 export class TransportStoreModule {}
